import { RouterProvider } from 'react-router-dom';

import { useUpdateNotification } from '@/hooks/useUpdateNotification';

import { AppProviders } from './providers';
import { router } from './router';

function AppInner() {
  // Polea /__build.json cada 5 min + on visibility change. Muestra toast con
  // botón "Recargar" si detecta nueva versión deployada.
  useUpdateNotification();
  return <RouterProvider router={router} />;
}

export default function App() {
  return (
    <AppProviders>
      <AppInner />
    </AppProviders>
  );
}
